import { createFileRoute } from "@tanstack/react-router";
import { FigmaPage } from "./-figma/figma.page";

export const Route = createFileRoute("/figma/")({
  component: FigmaPage,
  validateSearch: (search: Record<string, unknown>) => search,
});
